import { Pipe, PipeTransform } from '@angular/core';
import { SlicePipe } from '@angular/common';

@Pipe({
    name: 'trimText',
    standalone: false
})
export class TrimTextPipe implements PipeTransform {

  transform(fileName: string): string {
    return fileName.length > 20 ?
      new SlicePipe().transform(fileName, 0, 18) + '...'
      : fileName;
  }
}
